import { createAction, props } from '@ngrx/store';

export const UpdateUserState = createAction('[User] Update user props', props<{ payload }>());

export const UpdateGoogleAnalyticsClientId = createAction('[User] Update Google Analytics client id', props<{ payload: { ga: string } }>());

export const UpdateCookieConsent = createAction('[User] Update Cookie Consent', props<{ payload: { cookieConsent: boolean } }>());
